import { format } from 'date-fns'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IProperty } from 'src/interfaces/IProperty'

interface IPropertyInfo {
  property: IProperty
}

const PropertyInfo: FC<IPropertyInfo> = ({ property }) => {
  const { t } = useTranslation()
  return (
    <ul className="flex flex-wrap gap-2.5 items-center text-sm">
      <li className="flex items-center gap-2.5">
        {t('announcement_created_on')} {format(new Date(property?.createdAt), 'dd.MM.yyyy')}
      </li>
      <li className="flex items-center gap-2.5">
        <i className="icon w-[.3125rem] h-[.3125rem] rounded-full bg-ink/30 shrink-0" />
        <span className="">ID {property.id}</span>
      </li>
      {typeof property.viewsCount === 'number' && (
        <li className="flex items-center gap-2.5">
          <i className="icon w-[.3125rem] h-[.3125rem] rounded-full bg-ink/30 shrink-0" />
          {t('views')} {property.viewsCount}
        </li>
      )}
    </ul>
  )
}

export default PropertyInfo
